import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f43b0b68")

_pushScopeId("data-v-f43b0b68")
const _hoisted_1 = { class: "UsersList" }
const _hoisted_2 = { class: "UsersList__list" }
const _hoisted_3 = {
  key: 0,
  class: "UsersList__loader"
}
const _hoisted_4 = {
  key: 1,
  class: "UsersList__failed"
}
const _hoisted_5 = /*#__PURE__*/_createVNode("p", { class: "failed__text" }, "При получении пользователей произошла ошибка", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_create_user = _resolveComponent("create-user")!
  const _component_user_card = _resolveComponent("user-card")!
  const _component_load_more_users = _resolveComponent("load-more-users")!
  const _component_s_loader = _resolveComponent("s-loader")!
  const _component_icon_refresh = _resolveComponent("icon-refresh")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_create_user, { onClick: _ctx.emitCreate }, null, 8, ["onClick"]),
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.users, (user, i) => {
        return (_openBlock(), _createBlock(_component_user_card, {
          key: `User-${i}`,
          user: user,
          onEdit: _ctx.emitUpdate,
          onDelete: _ctx.emitDelete
        }, null, 8, ["user", "onEdit", "onDelete"]))
      }), 128)),
      (!_ctx.loading && _ctx.totalPages > _ctx.currentPage)
        ? (_openBlock(), _createBlock(_component_load_more_users, {
            key: 0,
            onClick: _ctx.emitLoadmore
          }, null, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _createVNode(_component_s_loader)
        ]))
      : _createCommentVNode("", true),
    (_ctx.failed && !_ctx.loading)
      ? (_openBlock(), _createBlock("div", _hoisted_4, [
          _hoisted_5,
          _createVNode(_component_icon_refresh, {
            class: "failed__icon",
            onClick: _ctx.emitRefresh
          }, null, 8, ["onClick"])
        ]))
      : _createCommentVNode("", true)
  ]))
})